<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  postDblpacking,
  showDblpacking,
  addDblpackingTrace,
  updateOrderInfo,
  getDownPort,
  move,
  // del,
  // boundTime,
  // addTrace,
  // handlePacking,
  // exportPacking,
  // exportPackingZip,
  // exportCustomsData,
  // exportOutboundData
} from "@/api/packing/packing";
import { getWarehouse } from "@/api/storage/warehouse";
import { getUser } from "@/api/user/internal";
import { getSelectType, getKeysType } from "@/api/public";
import { getTransportAgent, addZhongGang } from "@/api/tracker/air";
import cTable from "@/base/common/index";
import {fetchOperationLog} from "@/api/tracker/params";
export default {
  name: "b2bPackingList",
  components: {
    cTable,
  },
  async mounted() {
    let hkAgentList = (await getTransportAgent({ type: 4 })).data.payload;
    let warehouse = (await getWarehouse({ is_oversea: "NO", status: "ENABLE" }))
      .data.payload.rows;
    let clearanceAgentList = (await getTransportAgent({ type: 20 })).data.payload;
    let userList = (await getUser()).data.payload.rows;
    let downPortList = (await getDownPort()).data.payload;
    this.header.searchs.forEach((item) => {
      if (item.key === "warehouseId") item.options = warehouse;
      if (item.key === "operator") item.options = userList;
    });
    this.modals.update.fields.forEach((item) => {
      if (item.key === "hk_agent") item.options = hkAgentList;
      if (item.key === "lower_port") item.options = downPortList;
      if (item.key === "clearance_agent_id") item.options = clearanceAgentList
    });
  },
  data() {
    let trackList = {
        90: { label: "CustomsReleased", value: 90 },
        91: { label: "CustomsInspection", value: 91 },
        92: { label: "FormalClearance", value: 92 },
        93: { label: "CustomsHold", value: 93 },
      },
      typeList = {
        in: { label: "MoveIn", value: "in" },
        out: { label: "MoveOut", value: "out" },
      },
      globalUrl = this.$globalUrl;
    return {
      methods: {
        list: postDblpacking,
        showDblpacking,
        addDblpackingTrace,
        addZhongGang,
        updateOrderInfo,
        move,
        // exportOutboundData,
        // del,
        // boundTime,
        // addTrace,
        // handlePacking,
        // exportPacking,
        // exportPackingZip,
        // exportCustomsData
        // confirmError
      },
      modals: {
        operationModal: {
          config: {
            modalBind: {
              width: 720,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {},
          },
          footer: {
            show: () => false,
          },
          table: {
            config: {
              height: 750,
            },
            footer: {
              show: () => false,
            },
            fields: [
              {
                name: () => this.$t("操作时间"),
                key: "operation_time",
                minWidth: 180,
              },
              {
                name: () => this.$t("操作人"),
                key: "operator",
                minWidth: 120,
              },
              {
                name: () => this.$t("操作说明"),
                key: "remarks",
                minWidth: 400,
              },

            ],
          },
        },
        update: {
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data["type"] = 2;
              this.$page
                .handleRequestMethods("updateOrderInfo", data, true)
                .then((e) => {
                  this.$page.getList();
                  this.close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 540,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 20,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {},
          },
          grid: [
            {
              weight: 24,
            },
            {
              quantity: 24,
            },
            {
              volume: 24,
            },
            {
              liquid_num: 24,
            },
            {
              charged_num: 24,
            },
            {
              charging_weight: 24,
            },
            { hk_agent: 24 },
            { lower_port: 24 },
            { clearance_agent_id: 24 }
          ],
          fields: [
            {
              name: () => this.$t("invoiceWeight"),
              key: "weight",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              },
              default: 0,
            },
            {
              name: () => this.$t("invoicePCS"),
              key: "quantity",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoicePCS");
              },
              default: 0,
            },
            {
              name: () => this.$t("skuVolume"),
              key: "volume",
              component: "Input",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return this.$t("enter") + this.$t("skuVolume");
              },
              default: 0,
            },
            {
              name: () => this.$t("liquidPCS"),
              key: "liquid_num",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return this.$t("enter") + this.$t("liquidPCS");
              },
              default: 0,
            },
            {
              name: () => this.$t("ElectricityPCS"),
              key: "charged_num",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return this.$t("enter") + this.$t("ElectricityPCS");
              },
              default: 0,
            },
            {
              name: () => this.$t("Billing") + this.$t("invoiceWeight"),
              key: "charging_weight",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%",
                },
                min: 0,
              },
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("Billing") +
                  this.$t("invoiceWeight")
                );
              },
              default: 0,
            },
            {
              key: "hk_agent",
              name: () => this.$t("HKagency"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("HKagency");
              },
              options: [],
            },
            {
              key: "lower_port",
              name: () => this.$t("delivery_method"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("delivery_method");
              },
              options: [],
            },
            {
              key: "clearance_agent_id",
              name: () => '清关代理',
              component: "Select",
              placeholder() {
                return this.$t("select") + '清关代理';
              },
              options: []
            }
          ],
        },
        settime: {
          type: "add",
          methods: {
            ok({ row, close }) {
              row["method"] = "put";
              this.$page.handleRequestMethods("list", row, true).then((e) => {
                this.$page.getList();
                close();
              });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 400,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              time: [
                {
                  required: true,
                  message: "Please select the date and Time",
                  trigger: "change",
                  type: "date",
                },
              ],
            },
          },
          grid: [{ time: 24 }],
          fields: [
            {
              key: "time",
              name: () => this.$t("select") + this.$t("time"),
              component: "DatePicker",
              placeholder() {
                return this.$t("select") + this.$t("start") + this.$t("time");
              },
              bind: {
                type: "datetime",
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  },
                },
                clearable: false,
              },
            },
          ],
        },
        move: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("move", row, true).then((e) => {
                this.$page.getList();
                this.close();
              });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 540,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              type: [
                {
                  required: true,
                  trigger: "change",
                  type: "number",
                },
              ],
              airway_number: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{ type: 24 }, { airway_number: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("B2bOrderNo"),
              placeholder() {
                return this.$t("enter") + this.$t("B2bOrderNo");
              },
              bind: {
                type: "textarea",
                rows: 4,
              },
              component: "Input",
            },
            {
              key: "type",
              name: () => this.$t("type"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("type");
              },
              options: [
                { label: this.$t("MoveIn"), value: 1 },
                { label: this.$t("MoveOut"), value: 2 },
              ],
            },
          ],
        },
        track: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addDblpackingTrace", row, true)
                .then((e) => {
                  this.$page.getList();
                  this.close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 540,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              time: [
                {
                  required: true,
                  message: "Please select the date and Time",
                  trigger: "change",
                  type: "date",
                },
              ],
              status_code: [
                {
                  required: true,
                  message: "Please select the track",
                  trigger: "change",
                  type: "number",
                },
              ],
            },
          },
          grid: [{ time: 24 }, { status_code: 24 }],
          fields: [
            {
              key: "time",
              name: () => this.$t("select") + this.$t("time"),
              component: "DatePicker",
              placeholder() {
                return this.$t("select") + this.$t("start") + this.$t("time");
              },
              bind: {
                type: "datetime",
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  },
                },
                clearable: false,
              },
            },
            {
              key: "status_code",
              name: () => this.$t("tracker_description"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("tracker_description");
              },
              options: trackList,
              config: {
                label({ row, field }) {
                  return this.$t(row.label);
                },
              },
            },
          ],
        },
        operate: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("handlePacking", row, true)
                .then((e) => {
                  this.$page.getList();
                  this.close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 540,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 20,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              package: [
                {
                  required: true,
                  message: "Please enter the package",
                  trigger: "blur",
                },
              ],
              type: [
                {
                  required: true,
                  message: "Please select the Type",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            {
              package: 24,
            },
            {
              type: 24,
            },
          ],
          fields: [
            {
              name: () => this.$t("enter") + this.$t("bagCode"),
              key: "package",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bagCode");
              },
            },
            {
              name: () => this.$t("type"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("type");
              },
              key: "type",
              options: typeList,
              config: {
                label({ row, field }) {
                  return this.$t(row.label);
                },
              },
            },
          ],
        },
        show: {
          config: {
            listFn: "list",
            modalBind: {
              width: 800,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("orderNum"),
                key: "airway_number",
                align: "center",
                tooltip: true,
                width: 150,
                header: {
                  copy: true,
                },
                copy: true,
              },
              {
                name: () => this.$t("packingNum"),
                key: "case_number",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("length"),
                key: "length",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("width"),
                key: "width",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("height"),
                key: "height",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("createTime"),
                key: "create_time",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        setHkAgent: {
          methods: {
            ok({ row, close }) {
              row["type"] = 2;
              this.$page
                .handleRequestMethods("addZhongGang", row, true)
                .then((e) => {
                  this.$page.getList();
                  this.close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            title: () => this.$t("setting") + this.$t("HKagency"),
            modalBind: {
              width: 540,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              hk_agent: [
                {
                  required: true,
                  message: "Please select the track",
                  trigger: "change",
                  type: "number",
                },
              ],
            },
          },
          grid: [{ hk_agent: 24 }],
          fields: [
            {
              key: "hk_agent",
              name: () => this.$t("HKagency"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("HKagency");
              },
              options: this.hkAgentList,
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "timeType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            config: {
              label({ row, field }) {
                return this.$t(row.label);
              },
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["DBL_PACKING_SELECT_TIME"]))
                  .data.payload["DBL_PACKING_SELECT_TIME"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "warehouseId",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id",
            },
          },
          {
            key: "operator",
            placeholder() {
              return this.$t("select") + this.$t("status_operator");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keywords") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getKeysType("DBL_PACKING_KEYWORDS")).data
                  .payload;
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              btnBind: {
                type: "primary",
              },
              list: [
                {
                  name: () => this.$t("LibraryDay"),
                  type: "exportOutboundData",
                  fnName: "exportFun",
                },
                {
                  name: () => this.$t("Customsinfo"),
                  type: "exportCustomsData",
                  fnName: "exportFun",
                },
                {
                  name: () => this.$t("packingData"),
                  type: "exportPackingZip",
                  fnName: "exportFun",
                },
                {
                  name: () => this.$t("ListData"),
                  type: "ListData",
                  fnName: "ListData",
                  disabled() {
                    return !this.selectAll.length;
                  },
                },
              ],
            },
          ],
          methods: {
            exportFun({ field, searchForm }) {
              let data = {
                startTime: searchForm.startTime,
                endTime: searchForm.endTime,
                timeType: searchForm.timeType,
                warehouseId: searchForm.warehouseId,
                operator: searchForm.operator,
                keywords: searchForm.keywords,
              };
              this.openLoading();
              this.handleRequestMethods(field.type, data, false, true).then(
                (res) => {
                  window.open(globalUrl + res.payload.url);
                }
              );
            },
            // 导出列表数据
            ListData() {
              let fields = [
                {
                  name: this.$t("packing_number"),
                  key: "packing_number",
                },
                {
                  name: this.$t("ShippingDate"),
                  key: "outbound_time",
                },
                {
                  name: this.$t("createUser"),
                  key: "operator_name",
                },
                {
                  name: this.$t("bagsNum"),
                  key: "package_total",
                },
                {
                  name: this.$t("skuVolume"),
                  key: "volume_size",
                },
                {
                  name: this.$t("CustomsClearer"),
                  key: "clearance_agent_name",
                },
                {
                  name: this.$t("orderNums"),
                  key: "order_total",
                },
                {
                  name: this.$t("actual_weight"),
                  key: "order_weight",
                },
              ];
              this.openLoading();
              this.handleRequestMethods(
                "exportPacking",
                {
                  packing_id: this.selectAll.map((item) => item.id),
                },
                false,
                true
              ).then((res) => {
                this.exportExc({ data: res.payload, fields });
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          show: false,
          fixed: "left",
        },
        {
          name: () => this.$t("packing_number"),
          key: "packing_number",
          align: "center",
          minWidth: 150,
          fixed: "left",
        },
        {
          name: () => this.$t("Weight"),
          key: "weight",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("skuVolume"),
          key: "volume",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("liquidPCS"),
          key: "liquid_num",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("number_of_bags"),
          key: "quantity",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("ElectricityPCS"),
          key: "charged_num",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("Billing") + this.$t("invoiceWeight"),
          key: "charging_weight",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehosueTitle",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("endGang"),
          key: "target_airport",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$t("agentName"),
          key: "agent_name",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("HKagency"),
          key: "hk_agent_txt",
          width: 130,
          // render: (h, params) => {
          //   return h(
          //     "div",
          //     {
          //       style: {
          //         overflow: "hidden",
          //         "text-overflow": "ellipsis",
          //         "white-space": "nowrap",
          //         width: params.row.hk_agent.length > 6 ? "101%" : "100%"
          //       }
          //     },
          //     [
          //       h(
          //         !params.row.hk_agent ? "Button" : "span",
          //         {
          //           props: {
          //             type: "warning",
          //             size: "small"
          //           },
          //           on: {
          //             click: () => {
          //               if (!params.row.hk_agent) {
          //                 this.$refs["table"]
          //                   .getModal("setHkAgent")
          //                   .open({ id: params.row.id });
          //               }
          //             }
          //           }
          //         },
          //         params.row.hk_agent
          //           ? params.row.hk_agent
          //           : this.$t("setting") + this.$t("HKagency")
          //       )
          //     ]
          //   );
          // }
        },
        {
          name: () => this.$t("delivery_method"),
          key: "lower_port",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("createUser"),
          key: "operator_name",
          align: "center",
          minWidth: 100,
        },

        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 180,
        },
        {
          name: () => this.$t("outboundTime"),
          key: "outbound_time",
          component: "Button",
          align: "center",
          minWidth: 180,
          bind: {
            type: "warning",
            size: "small",
          },
          disabled: ({ value }) => {
            return !!value;
          },
          methods: {
            render: ({ row }) => {
              return row.outbound_time ? row.outbound_time : "Make Outbound";
            },
            click({ row }) {
              this.$page
                .getModal("settime")
                .open(
                  { id: row.id, type: "out", time: new Date() },
                  function () {
                    this.setTitle(this.$t("update") + this.$t("outboundTime"));
                    this.fields[0].name = this.$t("outboundTime");
                  }
                );
            },
          },
        },
        {
          name: () => this.$t("toHKtime"),
          key: "inbound_time",
          component: "Button",
          align: "center",
          minWidth: 180,
          bind: {
            type: "warning",
            size: "small",
          },
          disabled: ({ row }) => {
            return row.outbound_time === "";
          },
          methods: {
            render: ({ value }) => {
              return value ? value : "Make Outbound";
            },
            click({ row }) {
              this.$page
                .getModal("settime")
                .open(
                  { id: row.id, type: "in", time: new Date() },
                  function () {
                    // this.setFormData(data);
                    this.setTitle(this.$t("update") + this.$t("toHKtime"));
                    this.fields[0].name = this.$t("toHKtime");
                  }
                );
            },
          },
        },
        {
          type: "btns",
          width: 170,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
            },
            {
              name: () => this.$t("show"),
              type: "show",
              fnName: "showFun",
              bind: {
                type: "primary",
              },
              id: 524,
            },
            {
              name: () => this.$t("trackRecord"),
              type: "track",
              fnName: "trackFun",
              bind: {
                type: "warning",
              },
              id: 525,
            },
            {
              name: () => this.$t("MoveIn") + this.$t("MoveOut"),
              type: "move",
              fnName: "move",
              bind: {
                type: "primary",
              },
              id: 1243,
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
              show: ({ row }) => {
                return row.is_del == 1;
              },
            },
            {
              name: () => this.$t("操作记录"),
              type: "operationLog",
              fnName: "operationLog",
              bind: {
                type: "success"
              }
            },
          ],

          methods: {
            operationLog({ row }) {
              fetchOperationLog(row.mawb || row.packing_number).then(res => {

                this.getModal("operationModal").open(row, function() {
                  this.list = res.data.payload
                })
              })
            },
            move({ row, field }) {
              this.getModal("move").open({ id: row.id }, function () {
                this.setTitle(field.name() + `(${row.packing_number})`);
              });
            },
            updateFun({ row }) {
              this.getModal("update").open(row, function () {
                this.setTitle(this.$t("update") + row.packing_number);
              });
            },
            async showFun({ row }) {
              let res = await this.handleRequestMethods("showDblpacking", {
                packing_number: [row.packing_number],
              });
              console.log(res, this.getModal("show"));
              this.getModal("show").open({ data: res.payload.rows }, () => {
                this.getModal("show").setTitle(
                  this.$t("show") + row.packing_number
                );
                // this.getModal("show").table.fields[0].name = () => {
                //   return this.$t("packingNum");
                // };
                this.getModal("show").list = res.payload.rows;
              });
            },
            trackFun({ row }) {
              this.getModal("track").open(
                { time: new Date(), status_code: "", id: row.id },
                function () {
                  this.setTitle(this.$t("trackRecord"));
                }
              );
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  '"' +
                  row.packing_number +
                  '"' +
                  this.$t("packing_number") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "list",
                    {
                      id: row.id,
                      method: "delete",
                    },
                    true
                  ).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style lang="scss" scoped></style>
